import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTenderData } from 'src/models/procurements/Tender/hooks';
import { TenderSubCatName, TenderBlockSize, TenderBoxMode } from 'src/models/procurements/Tender/types';
import { isAddition } from 'src/models/procurements/Tender/helpers';
import { Translations } from 'src/lib/I18nService/types';
import { TenderBox, TenderSubCat } from 'src/shared';

export const ContractSubCat: FC = () => {
  const { t: tenderT } = useTranslation(Translations.procurements);
  const { data } = useTenderData();
  const isEditable = !!data?.isEditable;
  const subCat = data?.generalCat[TenderSubCatName.Contract];
  const startBox = useMemo(
    () =>
      subCat?.boxes.contractStartAndEndStart && !!subCat.boxes.contractStartAndEndStart.length
        ? subCat.boxes.contractStartAndEndStart[0]
        : undefined,
    [subCat]
  );
  const endBox = useMemo(
    () =>
      subCat?.boxes.contractStartAndEndEnd && !!subCat.boxes.contractStartAndEndEnd.length
        ? subCat.boxes.contractStartAndEndEnd[0]
        : undefined,
    [subCat]
  );
  const estimValueBox = useMemo(
    () =>
      subCat?.boxes.contractValueBoxes && !!subCat.boxes.contractValueBoxes.length
        ? subCat.boxes.contractValueBoxes[0]
        : undefined,
    [subCat]
  );
  const durationBox = useMemo(
    () =>
      subCat?.boxes.contractDurationBoxes && !!subCat.boxes.contractDurationBoxes.length
        ? subCat.boxes.contractDurationBoxes[0]
        : undefined,
    [subCat]
  );
  const renewalBox = useMemo(
    () =>
      subCat?.boxes.contractRenewalBoxes && !!subCat.boxes.contractRenewalBoxes.length
        ? subCat.boxes.contractRenewalBoxes[0]
        : undefined,
    [subCat]
  );
  const suppliersBox = useMemo(
    () =>
      subCat?.boxes.numberOfSuppliersAssignedContract && !!subCat.boxes.numberOfSuppliersAssignedContract.length
        ? subCat.boxes.numberOfSuppliersAssignedContract[0]
        : undefined,
    [subCat]
  );

  return (
    <>
      {subCat && (
        <TenderSubCat subCat={{ ...subCat, size: TenderBlockSize.Half }} boxTheme={false}>
          <TenderBox
            box={startBox}
            title={tenderT('Contract start date')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            isInfo={isAddition(subCat?.boxes.contractStartAndEndStart)}
            isFirstField
            isEditable={isEditable}
          />
          <TenderBox
            box={endBox}
            title={tenderT('Contract end date')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            isInfo={isAddition(subCat?.boxes.contractStartAndEndEnd)}
            isFirstField
            isEditable={isEditable}
          />
          <TenderBox
            box={estimValueBox}
            title={tenderT('Estimated contract value')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            isInfo={isAddition(subCat?.boxes.contractValueBoxes)}
            isFirstField
            isEditable={isEditable}
          />
          <TenderBox
            box={durationBox}
            title={tenderT('Contract duration')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            isInfo={isAddition(subCat?.boxes.contractDurationBoxes)}
            isFirstField
            isEditable={isEditable}
          />
          <TenderBox
            box={renewalBox}
            title={tenderT('Contract renewal')}
            as={TenderBoxMode.Custom}
            isInfo={isAddition(subCat?.boxes.contractRenewalBoxes)}
            size={TenderBlockSize.Half}
            isFirstField
            isEditable={isEditable}
          />
          <TenderBox
            box={suppliersBox}
            title={tenderT('The number of suppliers assigned to framework agreement')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            isInfo={isAddition(subCat?.boxes.numberOfSuppliersAssignedContract)}
            isFirstField
            isEditable={isEditable}
          />
        </TenderSubCat>
      )}
    </>
  );
};

export default ContractSubCat;
